<div class="history-tab">
  <div *ngIf="loadError" class="error">{{ loadError }}</div>

  <div *ngIf="!loadError && history.length === 0" class="empty">No history yet.</div>

  <table mat-table [dataSource]="history" *ngIf="history.length > 0" class="history-table">
    <ng-container matColumnDef="timestamp">
      <th mat-header-cell *matHeaderCellDef>Date</th>
      <td mat-cell *matCellDef="let h">{{ h.timestamp | date:'MM/dd/yyyy h:mm a' }}</td>
    </ng-container>
    <ng-container matColumnDef="actionType">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let h"><span class="type-chip" [ngClass]="typeClass(h.actionType)">{{ h.actionType }}</span></td>
    </ng-container>
    <ng-container matColumnDef="userName">
      <th mat-header-cell *matHeaderCellDef>User</th>
      <td mat-cell *matCellDef="let h">{{ h.userName || h.userId || 'System' }}</td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>Detail</th>
      <td mat-cell *matCellDef="let h">
        {{ h.description }}
        <span *ngIf="h.attribute && !h.description">{{ h.attribute }}: {{ h.oldValue }} → {{ h.newValue }}</span>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
